import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Button,
  HStack,
  Box,
  useDisclosure,
} from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import { getEffectivePlan } from '../utils/planConfig';
import { formatDateDMY } from '../utils/formatDate';
import UpgradePlanModal from './UpgradePlanModal';

const TrialBanner: React.FC = () => {
  const { organization, user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isAdmin = user?.role === 'admin';

  if (!organization?.trialEndsAt) return null;

  const trialEnd = new Date(organization.trialEndsAt);
  const now = new Date();
  if (trialEnd <= now) return null;

  const effectivePlan = getEffectivePlan(organization.plan, organization.trialEndsAt);
  if (effectivePlan !== 'pro' && organization.plan !== 'free') return null;

  const daysLeft = Math.ceil((trialEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  const urgent = daysLeft <= 3;

  return (
    <>
      <Alert
        status={urgent ? 'warning' : 'info'}
        borderRadius="xl"
        mb={6}
        flexDirection={{ base: 'column', md: 'row' }}
        alignItems={{ base: 'flex-start', md: 'center' }}
        gap={3}
      >
        <HStack align="flex-start" flex="1">
          <AlertIcon />
          <Box>
            <AlertTitle fontSize="sm">Pro trial active</AlertTitle>
            <AlertDescription fontSize="sm">
              {daysLeft} day{daysLeft !== 1 ? 's' : ''} left (ends {formatDateDMY(organization.trialEndsAt)}).
              Upgrade before trial ends to keep Pro features.
            </AlertDescription>
          </Box>
        </HStack>
        {isAdmin && (
          <Button size="sm" colorScheme="blue" onClick={onOpen}>
            Upgrade now
          </Button>
        )}
      </Alert>
      {isAdmin && <UpgradePlanModal isOpen={isOpen} onClose={onClose} />}
    </>
  );
};

export default TrialBanner;
